// Checkout 3 etapas
(function () {
  'use strict';

  if (previewMode || checkoutStepsEnable) {
    // Variáveis
    const $sections = $('.co-infos, .co-address-wrp, .co-shipping-ways-wrp, .co-payment');
    const $stepsTimeline = $('.checkout-step');
    const $hideElementsEnd = $('.co-orderbumpX');
    const $secAddressAll = $('.co-address');
    let curStep;

    // INFORMAÇÕES PESSOAIS
    const $s1Section = $('.co-infos');
    // Ao clicar para avançar
    $s1Section.find('.checkout-nav-next').on('click', function (ev) {
      ev.preventDefault();
      const step = 'infos';
      validateStep(step, function () {
        completeStep(step);
        if (!checkoutNoAddress) {
          gotoStep('address');
        } else {
          gotoStep('payment');
        }
      });
    });
    // Ao clicar para editar
    $s1Section.find('.sec-step-infos .btn').on('click', function (ev) {
      ev.preventDefault();
      const step = 'infos';
      validateStep(curStep, function () {
        completeStep(curStep);
        gotoStep(step);
      });
    });

    // ENDEREÇO DE ENTREGA/COBRANÇA
    const $s2Section = $('.co-address-wrp');
    // Ao clicar para avançar
    $s2Section.find('.checkout-nav-next').on('click', function (ev) {
      ev.preventDefault();
      const step = 'address';
      validateStep(step, function () {
        completeStep(step);
        if (!checkoutDigitalActive) {
          gotoStep('shipping');
        } else {
          gotoStep('payment');
        }
      });
    });
    // Ao clicar para editar
    $s2Section.find('.sec-step-infos .btn').on('click', function (ev) {
      ev.preventDefault();
      const step = 'address';
      validateStep(curStep, function () {
        completeStep(curStep);
        gotoStep(step);
      });
    });

    // FORMAS DE ENTREGA
    const $s3Section = $('.co-shipping-ways-wrp');
    // Ao clicar para avançar
    $s3Section.find('.checkout-nav-next').on('click', function (ev) {
      ev.preventDefault();
      const step = 'shipping';
      validateStep(step, function () {
        completeStep(step);
        gotoStep('payment');
      });
    });
    // Ao clicar para editar
    $s3Section.find('.sec-step-infos .btn').on('click', function (ev) {
      ev.preventDefault();
      const step = 'shipping';
      validateStep(curStep, function () {
        completeStep(curStep);
        gotoStep(step);
      });
    });

    // FORMAS DE PAGAMENTO
    const $s4Section = $('.co-payment');
    // Ao clicar para editar
    $s4Section.on('click', function (ev) {
      if ($s4Section.hasClass('completed') && !$s4Section.hasClass('current')) {
        ev.preventDefault();
        const step = 'payment';
        validateStep(curStep, function () {
          completeStep(curStep);
          gotoStep(step);
        });
      }
    });

    // Realiza a navegação através da timeline
    $('.checkout-step').on('click', function (ev) {
      ev.preventDefault();
      const $step = $(this);
      const step = $(this).data('step');
      //if ($step.hasClass('active') && !$step.hasClass('current')) {
      if (!$step.hasClass('current')) {
        validateStep(curStep, function () {
          completeStep(curStep);
          gotoStep(step);
        });
      }
    });

    // Realiza a navegação para a etapa passada por parâmetro
    function gotoStep(step) {
      console.log('goto ==> ' + step);
      curStep = step;
      localStorage.setItem('last-step', step);
      $sections.removeClass('current');
      $secAddressAll.removeClass('current');
      $hideElementsEnd.hide();
      updStepTimeline();
      // Informações pessoais
      if (curStep === 'infos') {
        $s1Section.addClass('current');
        $s1Section.removeClass('completed');
        verifyValidInputs();
        if (!$('#co-name').val()) {
          if (!previewMode) {
            setTimeout(() => {
              $('#co-name').focus();
            }, 100);
          }
        }
      }
      // Endereço
      else if (curStep === 'address') {
        $secAddressAll.addClass('current');
        $s2Section.addClass('current');
        $s2Section.removeClass('completed');
        verifyValidInputs();
        if ($('#co-zipcode').length > 0) {
          if ($('#co-zipcode').val()) {
            $('.co-address-wrp .checkout-nav').show();
          } else {
            if (!previewMode) {
              setTimeout(() => {
                $('#co-zipcode').focus();
              }, 100);
            }
          }
        } else if ($('#co-zipcode-billing').length > 0) {
          if ($('#co-zipcode-billing').val()) {
            $('.co-address-wrp .checkout-nav').show();
          } else {
            if (!previewMode) {
              setTimeout(() => {
                $('#co-zipcode-billing').focus();
              }, 100);
            }
          }
        }
      }
      // Formas de entrega
      else if (step === 'shipping') {
        $secAddressAll.addClass('current');
        $s3Section.addClass('current');
        $s3Section.removeClass('completed');
        $s3Section.show();
      }
      // Formas de pagamento
      else if (step === 'payment') {
        $s4Section.addClass('current');
        $s4Section.removeClass('completed');
        $hideElementsEnd.show();
        dispatchPaymentInfo();
        setTimeout(() => {
          $('.co-orderbump-carrosel').trigger('reload-ob');
        }, 100);
      }
      if (curStep !== 'infos' && (isMedia('xl') || isMedia('lg')) && !checkoutStepsColsEnable) {
        setTimeout(() => {
          if (curStep === 'address' || curStep === 'shipping') {
            smoothScroll('.co-address');
          } else if (step === 'payment') {
            smoothScroll('.co-payment');
          }
        }, 100);
      }
    }

    $('body').on('checkout-layout-change', toggleCheckoutLayout);
    toggleCheckoutLayout();

    // Inicializa o checkout por etapas
    function initCheckoutSteps() {
      // Configura o plugin de validação por seções
      $sections.each(function () {
        const $sec = $(this);
        const step = $sec.data('checkout-step');
        const $inputs = $sec.find(':input');
        $inputs.attr('data-parsley-group', 'sec-' + step);
      });
      verifyCompleteSteps();
    }

    // Desabilita o checkout de etapas
    function disableCheckoutSteps() {
      $hideElementsEnd.show();
      if ($('.co-orderbump-carrosel').length) {
        $('.co-orderbump-carrosel').trigger('reload-ob');
      }
    }

    // Habilita ou desabilita o checkout de 3 etapas
    function toggleCheckoutLayout() {
      if ($('body').hasClass('steps-layout')) {
        initCheckoutSteps();
      } else {
        disableCheckoutSteps();
      }
    }

    // Atualiza a exibição da timeline
    function updStepTimeline() {
      $stepsTimeline.removeClass('active current');
      $stepsTimeline.each(function () {
        const $step = $(this);
        const step = $step.data('step');
        if (step === 'infos' && $s1Section.hasClass('completed')) {
          $step.addClass('active');
        }
        if (step === 'address' && $secAddressAll.hasClass('completed')) {
          $step.addClass('active');
        }
        /*  if (step === 'payment' && $s4Section.hasClass('completed')) {
          $step.addClass('active');
        } */
        if (curStep == step || (curStep == 'shipping' && step === 'address')) {
          $step.addClass('current');
          if (step === 'infos' && $secAddressAll.hasClass('completed')) {
            $step.addClass('current2');
          }
        }
      });
    }

    // Realiza a validação da etapa
    function validateStep(step, cb) {
      $('#form-checkout')
        .parsley()
        .whenValidate({
          group: 'sec-' + step,
        })
        .done(function () {
          cb();
        });
    }

    // Verifica se uma etapa está válida
    function isValidStep(step) {
      return $('#form-checkout')
        .parsley()
        .isValid({
          group: 'sec-' + step,
        });
    }

    // Marca uma etapa como completa e exibe as informações
    function completeStep(step) {
      const $sec = $('[data-checkout-step="' + step + '"]');
      $sec.addClass('completed');
      if (step === 'address' || step === 'shipping') {
        $secAddressAll.addClass('completed');
      }
      $sec.find('.sec-step-infos [data-info]').each(function () {
        const $el = $(this);
        const inputRef = $el.data('info');
        const $inputRef = $sec.find(inputRef);
        if ($inputRef.length > 0) {
          $el.text($inputRef.val());
        }
      });
    }

    // Verifica as seções que já estão válidas no carregamento e marca como completa
    function verifyCompleteSteps() {
      if (!checkoutNoAddress) {
        // Infos
        if (isValidStep('infos')) {
          completeStep('infos');
          // Endereço
          if (isValidStep('address')) {
            completeStep('address');
            // Entrega
            if (isValidStep('shipping')) {
              completeStep('shipping');
              gotoStep('payment');
              return;
            } else {
              gotoStep('shipping');
              return;
            }
          } else {
            gotoStep('address');
            return;
          }
        } else {
          gotoStep('infos');
          return;
        }
      } else {
        // Infos
        if (isValidStep('infos')) {
          completeStep('infos');
          gotoStep('payment');
          return;
        } else {
          gotoStep('infos');
          return;
        }
      }
    }
  }
})();
